(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["berlinger-recommendation"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

                    
            $(document).ready(function() {
              $('#featured-collection-container').slick({  
                  infinite: false,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  prevArrow: '<button type="button" class="slick-prev"></button>',
                  nextArrow: '<button type="button" class="slick-next"></button>',
                  responsive: [
                      {
                        breakpoint: 950,
                        settings: {
                          slidesToShow: 2
                        }
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 1
                        }
                      }
                  ]
              });
            });
 
        }
        
        
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemist-designer-solitaire"] && !Shopify.designMode) return;
  try {
    
  
const baseURL = "https://berlinger.gemist.co/";

window.onload = function() {
  // Get the current URL of the parent page
  var url = window.location.href;
  
  // Get the query string from the URL
  var queryString = url.split('?')[1];
  
  // Create the iframe URL with the query string
  var iframeUrl = baseURL + "designer/solitaire-ring?" + queryString;
  
  // Set the iframe's source URL
  var iframe = document.getElementById("designer-iframe");
     
  iframe.src = iframeUrl;
};

function removeItemsFromCart(items) {
  if (items.length <= 0) return;

  items.forEach(item => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item)
    })
    .then(response => response.json())
    .then(data => {
      var event = new Event('cart:refresh');
      document.dispatchEvent(event);
    })
    .catch(error => console.error("Error removing item from cart:", error));
  });
}

window.addEventListener("cart:change",
    function (event) {
      let variant_id;
      event.detail.cart.items_removed.forEach( item => {
        variant_id = item.variant_id;
      });

      if (variant_id === undefined) {
        return;
      }

      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          let relatedItems = data.items.filter(item => item.properties._variant_id == variant_id);
          let removeItems = []
          relatedItems.forEach(item => {
            removeItems.push({id: item.key, quantity: item.quantity - 1});
          });
          
          removeItemsFromCart(removeItems);
        })
        .catch(error => {
          console.error('Error fetching cart items:', error);
        });
    }
);
  
window.addEventListener( "message",
	function (event) {
		if (event.data) {
			try {
				const message = JSON.parse(event.data);
				switch (message.type) {
                    case "buy":
                    console.log(message);
                      var id = message.product.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0];
                      var size = message.size;

                      const items = [];
          
                      let product = {
                        id: id,
                        quantity: 1,
                        properties: {
                          Size: size,
                          _disable_click: true,
                        },
                      };

                      if (message.engravingTextRing != "") {
                        let engraving = {
                          id: "46358590292191",
                          quantity: 1,
                          properties: {
                            "Text": message.engravingTextRing.toUpperCase(),
                            _variant_id: id,
                            _disable_click: true,
                          }
                        };

                        product.properties.Engraving = message.engravingTextRing.toUpperCase();

                        items.push(engraving);
                      }
                    
                      if (message.matchingBand) {
                        let matchingBand = {
                          id: message.matchingBand.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0],
                          quantity: 1,
                          properties: {
                            _disable_click: true,
                          }
                        };

                        if (message.engravingRingBand != "") {
                          let engravingRingBand = {
                            id: "46358583574751",
                            quantity: 1,
                            properties: {
                              "Text": message.engravingRingBand.toUpperCase(),
                              _variant_id: matchingBand.id,
                              _disable_click: true,
                            }
                          };
  
                          matchingBand.properties.Engraving = message.engravingRingBand.toUpperCase();
  
                          items.push(engravingRingBand);
                        }
                        
                        items.push(matchingBand);
                      }

                      items.push(product);
          
                      if (message.diamond.variantId !== undefined) {
                        let diamond = {
                          id: message.diamond.variantId.split("/").slice(-1)[0],
                          quantity: 1,
                        };
                        items.push(diamond);
                      }

                      cart = window.cart || 
                        document.querySelector("cart-notification") ||
                        document.querySelector("cart-drawer");
          
                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ items: items }),
                      })
                        .then((response) => {
                          if (cart && typeof cart.getCart === 'function') {
                            cart.getCart();
                          }
                          var event = new Event('cart:refresh');
                          document.dispatchEvent(event);
                          
                          setTimeout(function() {
                            document.dispatchEvent(event);
                           window.location.href = "/cart";
                          }, 1000);
                        })
                        .catch((error) => {
                          console.error("Error:", error);
                        });

                      break;
                    case 'favorite':
                        var {id} = message.product;
                    
                        fetch(baseURL + 'api/products/' + id + '/shmetadata')
                        .then(response => response.json())
                        .then(data => {
                          var {productId, handle} = data;
                          
                          // create element to save
                          var elementToSave = document.createElement('div');
                          elementToSave.dataset.id = productId.split('/').slice(-1)[0];
                          elementToSave.dataset.handle = handle;
                          
                          // use the saveWishlist function that we made available from theme.js
                          saveWishlist($(elementToSave));
                        })
                        .catch((error) => {
							console.error('Error:', error);
						});
                        break;
                    case 'updateParams':
                        // Get the parameter names from the message
                        var paramNames = message.paramNames;
                        var currentURL = new URL(window.location.href);
                  
                        // Loop through the parameter names
                        paramNames.forEach(function(paramName) {
                          // Retrieve the corresponding value from the message
                          var paramValue = message[paramName];
                  
                          // Modify the query parameter of the parent URL with the value
                          if (paramValue !== undefined) {
                            currentURL.searchParams.set(paramName, paramValue);
                          }
                        });
                  
                        // Replace the parent URL with the modified URL
                        window.history.replaceState({}, "", currentURL.toString());
                        break;
                    case 'download':
                        const downloadHref = message.downloadHref;
                        if (downloadHref) {
                          window.open(downloadHref, "_blank");
                        }
						break;
                    case 'copywindowlocation':
                        // Get the current window location
                        var windowLocation = window.location.href;
                        
                        // Use the Clipboard API to copy the window location to the clipboard
                        navigator.clipboard.writeText(windowLocation)
                          .then(function() {
                            console.log("Window location copied to clipboard successfully");
                          })
                          .catch(function(error) {
                            console.error("Failed to copy window location to clipboard:", error);
                          });
						break;
                     case 'sendemail':
                        let {emailContent, subject, recipient} = message;
                        const currentPageLink = window.location.href;
                        emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);                   

                        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                          subject
                        )}&body=${encodeURIComponent(emailContent)}`;

                        if (mailtoLink) {
                          window.open(mailtoLink, "_blank");
                        }
						break;
                    case "requestfullscreen":
                        const designerIframe = document.querySelector("#designer-iframe");
                        void designerIframe.requestFullscreen();
                        break;
					default: 
						break;
				}
			} catch (e) {
              console.log("Designer error", e);
			}
		}
	},
	false
);

   // This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height, 
  // then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function () {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(
      ".designer-iframe-container"
    );
    const designerIFrameElement = document.querySelector("#designer-iframe");
    
    const selectorsToObserve = ["#shopify-section-header"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 0);

      if (
        designerIFrameContainerElement !== null &&
        designerIFrameElement !== null &&
        totalHeight
        ) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;
      
        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    
  
const baseURL = "https://berlinger.gemist.co/";

window.onload = function() {
  // Get the current URL of the parent page
  var url = window.location.href;
  
  // Get the query string from the URL
  var queryString = url.split('?')[1];
  
  // Create the iframe URL with the query string
  var iframeUrl = baseURL + "designer/engagement?" + queryString;
  
  // Set the iframe's source URL
  var iframe = document.getElementById("designer-iframe");
     
  iframe.src = iframeUrl;
};

function removeItemsFromCart(items) {
  if (items.length <= 0) return;

  items.forEach(item => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item)
    })
    .then(response => response.json())
    .then(data => {
      var event = new Event('cart:refresh');
      document.dispatchEvent(event);
    })
    .catch(error => console.error("Error removing item from cart:", error));
  });
}

window.addEventListener("cart:change",
    function (event) {
      let variant_id;
      event.detail.cart.items_removed.forEach( item => {
        variant_id = item.variant_id;
      });

      if (variant_id === undefined) {
        return;
      }

      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          let relatedItems = data.items.filter(item => item.properties._variant_id == variant_id);
          let removeItems = []
          relatedItems.forEach(item => {
            removeItems.push({id: item.key, quantity: item.quantity - 1});
          });
          
          removeItemsFromCart(removeItems);
        })
        .catch(error => {
          console.error('Error fetching cart items:', error);
        });
    }
);
  
window.addEventListener( "message",
	function (event) {
		if (event.data) {
			try {
				const message = JSON.parse(event.data);
				switch (message.type) {
                    case "buy":
                    console.log(message);
                      var id = message.product.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0];
                      var size = message.size;

                      const items = [];
          
                      let product = {
                        id: id,
                        quantity: 1,
                        properties: {
                          Size: size,
                          _disable_click: true,
                        },
                      };

                      if (message.engravingTextRing != "") {
                        let engraving = {
                          id: "46358590292191",
                          quantity: 1,
                          properties: {
                            "Text": message.engravingTextRing.toUpperCase(),
                            _variant_id: id,
                            _disable_click: true,
                          }
                        };

                        product.properties.Engraving = message.engravingTextRing.toUpperCase();

                        items.push(engraving);
                      }
                    
                      if (message.matchingBand) {
                        let matchingBand = {
                          id: message.matchingBand.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0],
                          quantity: 1,
                          properties: {
                            _disable_click: true,
                          }
                        };

                        if (message.engravingRingBand != "") {
                          let engravingRingBand = {
                            id: "46358583574751",
                            quantity: 1,
                            properties: {
                              "Text": message.engravingRingBand.toUpperCase(),
                              _variant_id: matchingBand.id,
                              _disable_click: true,
                            }
                          };
  
                          matchingBand.properties.Engraving = message.engravingRingBand.toUpperCase();
  
                          items.push(engravingRingBand);
                        }
                        
                        items.push(matchingBand);
                      }

                      items.push(product);
          
                      if (message.diamond.variantId !== undefined) {
                        let diamond = {
                          id: message.diamond.variantId.split("/").slice(-1)[0],
                          quantity: 1,
                        };
                        items.push(diamond);
                      }

                      cart = window.cart || 
                        document.querySelector("cart-notification") ||
                        document.querySelector("cart-drawer");
          
                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ items: items }),
                      })
                        .then((response) => {
                          if (cart && typeof cart.getCart === 'function') {
                            cart.getCart();
                          }
                          var event = new Event('cart:refresh');
                          document.dispatchEvent(event);
                          
                          setTimeout(function() {
                            document.dispatchEvent(event);
                            window.location.href = "/cart";
                          }, 1000);
                        })
                        .catch((error) => {
                          console.error("Error:", error);
                        });

                      break;
                    case 'favorite':
                        var {id} = message.product;
                    
                        fetch(baseURL + 'api/products/' + id + '/shmetadata')
                        .then(response => response.json())
                        .then(data => {
                          var {productId, handle} = data;
                          
                          // create element to save
                          var elementToSave = document.createElement('div');
                          elementToSave.dataset.id = productId.split('/').slice(-1)[0];
                          elementToSave.dataset.handle = handle;
                          
                          // use the saveWishlist function that we made available from theme.js
                          saveWishlist($(elementToSave));
                        })
                        .catch((error) => {
							console.error('Error:', error);
						});
                        break;
                    case 'updateParams':
                        // Get the parameter names from the message
                        var paramNames = message.paramNames;
                        var currentURL = new URL(window.location.href);
                  
                        // Loop through the parameter names
                        paramNames.forEach(function(paramName) {
                          // Retrieve the corresponding value from the message
                          var paramValue = message[paramName];
                  
                          // Modify the query parameter of the parent URL with the value
                          if (paramValue !== undefined) {
                            currentURL.searchParams.set(paramName, paramValue);
                          }
                        });
                  
                        // Replace the parent URL with the modified URL
                        window.history.replaceState({}, "", currentURL.toString());
                        break;
                    case 'download':
                        const downloadHref = message.downloadHref;
                        if (downloadHref) {
                          window.open(downloadHref, "_blank");
                        }
						break;
                    case 'copywindowlocation':
                        // Get the current window location
                        var windowLocation = window.location.href;
                        
                        // Use the Clipboard API to copy the window location to the clipboard
                        navigator.clipboard.writeText(windowLocation)
                          .then(function() {
                            console.log("Window location copied to clipboard successfully");
                          })
                          .catch(function(error) {
                            console.error("Failed to copy window location to clipboard:", error);
                          });
						break;
                     case 'sendemail':
                        let {emailContent, subject, recipient} = message;
                        const currentPageLink = window.location.href;
                        emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);                   

                        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                          subject
                        )}&body=${encodeURIComponent(emailContent)}`;

                        if (mailtoLink) {
                          window.open(mailtoLink, "_blank");
                        }
						break;
                    case "requestfullscreen":
                        const designerIframe = document.querySelector("#designer-iframe");
                        void designerIframe.requestFullscreen();
                        break;
					default: 
						break;
				}
			} catch (e) {
              console.log("Designer error", e);
			}
		}
	},
	false
);

   // This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height, 
  // then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function () {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(
      ".designer-iframe-container"
    );
    const designerIFrameElement = document.querySelector("#designer-iframe");
    
    const selectorsToObserve = ["#shopify-section-header"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 0);

      if (
        designerIFrameContainerElement !== null &&
        designerIFrameElement !== null &&
        totalHeight
        ) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;
      
        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > 30) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 30) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-archive"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
